// extracted by mini-css-extract-plugin
export default {"buttonHeader":"CategoriesTableHead_buttonHeader__xnZh8"};